'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}

export default function FAQItem({ question, answer, isOpen, onToggle }: FAQItemProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="bg-card border-2 border-border rounded-lg overflow-hidden transition-all duration-300">
        <button
          disabled
          className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-muted transition-colors duration-300"
        >
          <span className="font-heading font-semibold text-textPrimary pr-4">{question}</span>
          <Icon name="ChevronDownIcon" size={20} className="text-textSecondary flex-shrink-0" />
        </button>
      </div>
    );
  }

  return (
    <div className="bg-card border-2 border-border rounded-lg overflow-hidden transition-all duration-300 hover:border-primary hover:shadow-md">
      <button
        onClick={onToggle}
        className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-muted transition-colors duration-300"
        aria-expanded={isOpen}
      >
        <span className="font-heading font-semibold text-textPrimary pr-4">{question}</span>
        <Icon
          name="ChevronDownIcon"
          size={20}
          className={`text-textSecondary flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      {isOpen && (
        <div className="px-6 pb-4 pt-2 border-t border-border">
          <p className="text-textSecondary font-body leading-relaxed whitespace-pre-line">
            {answer}
          </p>
        </div>
      )}
    </div>
  );
}
